module.exports = __webpack_public_path__ + "img/mascotte-white.00298765.png";